<template>
  <el-tabs
      :value="activeTab || 'adGroup'"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adGroup" key="adGroup" lazy>
      <template #label>
        <span>广告组</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countGroups || 0"></gj-badge>
        </template>
      <app-sp-ad-group
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          :campaign="proxyCampaign"
          table-name="spAdCampaignGroup"
      ></app-sp-ad-group>
    </el-tab-pane>
    <el-tab-pane name="adLocation" key="adLocation" lazy>
      <template #label>
        <span>广告位</span>
        </template>
      <app-sp-ad-placement
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          table-name="spAdCampaignLocation"
      ></app-sp-ad-placement>
    </el-tab-pane>
    <el-tab-pane name="adProduct" key="adProduct" lazy>
      <template #label>
        <span>广告</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countAds || 0"></gj-badge>
      </template>
      <app-sp-ad-product
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          :campaign="proxyCampaign"
          table-name="spAdCampaignProduct"
      ></app-sp-ad-product>
    </el-tab-pane>
    <el-tab-pane
        v-if="AdCampaignEnum.SP.targetingType.AUTO === proxyCampaign.targetingType"
        key="adTargetGroup" name="adTargetGroup" lazy>
      <template #label>
        <span>投放组</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargetingGroups || 0"></gj-badge>
        </template>
      <app-sp-ad-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          table-name="spAdCampaignTargetGroup"
      ></app-sp-ad-target>
    </el-tab-pane>
    <el-tab-pane
        v-if="AdCampaignEnum.SP.targetingType.MANUAL === proxyCampaign.targetingType"
        key="adKeyword" name="adKeyword" lazy>
      <template #label>
        <span>关键词</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countKeywords || 0"></gj-badge>
        </template>
      <app-sp-ad-keyword
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          :campaign="proxyCampaign"
          table-name="spAdCampaignKeyword"
      ></app-sp-ad-keyword>
    </el-tab-pane>
    <el-tab-pane name="adNegKeyword" key="adNegKeyword" lazy>
      <template #label>
        <span>否定关键词</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeKeywords || 0"></gj-badge>
        </template>
      <app-sp-ad-neg-keyword
          :init-date="initDate"
          manager-type="adCampaignManager"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          :campaign="proxyCampaign"
          table-name="spAdCampaignNegKeyword"
      ></app-sp-ad-neg-keyword>
    </el-tab-pane>
    <el-tab-pane
        v-if="AdCampaignEnum.SP.targetingType.MANUAL === proxyCampaign.targetingType"
        name="adProductTarget" lazy>
      <template #label>
        <span>商品投放</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargeting || 0"></gj-badge>
        </template>
      <app-sp-ad-product-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          :campaign="proxyCampaign"
          table-name="spAdCampaignProductTarget"
      ></app-sp-ad-product-target>
    </el-tab-pane>
    <el-tab-pane name="adNegTarget" key="adNegTarget" lazy>
      <template #label>
        <span>否定商品投放</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeTargeting || 0"></gj-badge>
        </template>
      <app-sp-ad-neg-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          :campaign="proxyCampaign"
          table-name="spAdCampaignNegTarget"
      ></app-sp-ad-neg-target>
    </el-tab-pane>
    <el-tab-pane name="adSearchKeyword" key="adSearchKeyword" lazy>
      <template #label>
        <span>用户搜索词</span>
        </template>
      <app-sp-ad-search-keyword
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :portfolio-id="portfolioId"
          table-name="spAdCampaignSearchKeyword"
      ></app-sp-ad-search-keyword>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSpAdGroup from "../components/ad-group/ad-group";
  import AppSpAdPlacement from "../components/ad-placement/ad-placement";
  import AppSpAdProduct from "../components/ad-product/ad-product";
  import AppSpAdKeyword from "../components/ad-keyword/ad-keyword";
  import AppSpAdNegKeyword from "../components/ad-neg-keyword/ad-neg-keyword";
  import AppSpAdSearchKeyword from "../components/ad-search-word/ad-search-word";
  import AppSpAdProductTarget from "../components/ad-product-target/ad-product-target";
  import {AdCampaignEnum} from "../../common/enum";
  import AppSpAdTarget from "../components/ad-target/ad-target";
  import {inCampaignMixin, initDateMixin, inMarketMixin, inPortfolioMixin, tabResizeMixin} from "../../common/mixin";
  import AppSpAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import { SP } from "@/api/ad";
  import {adStore} from "../../common/store";
  import {isMeaningful} from "@/utils/common";
  export default {
    name: "app-sp-ad-campaign-manager",
    components: {
      AppSpAdNegTarget,
      AppSpAdTarget,
      AppSpAdProductTarget,
      AppSpAdSearchKeyword, AppSpAdNegKeyword, AppSpAdKeyword, AppSpAdProduct, AppSpAdPlacement, AppSpAdGroup},
    mixins: [inMarketMixin, inCampaignMixin, inPortfolioMixin, tabResizeMixin, initDateMixin],
    inject: ['cornerMarkerMap'],
    props: {
      activeTab: {
        default: 'adGroup',
      }
    },
    created() {
    
    },
    data() {
      return {
        AdCampaignEnum: AdCampaignEnum,
        proxyCampaign: {}
      }
    },
    computed: {
      cornerMarker() {
        return this.cornerMarkerMap()
      }
    },
    methods: {
      campaignChange(campaignId) {
        SP.getCampaignDetails({
          marketId: this.marketId,
          campaignId,
        })
          .then(({data}) => {
            if (isMeaningful(data)) {
              this.proxyCampaign = data;
            }
          })
          .complete(() => {});
      }
    },
    beforeRouteEnter(to, from, next) {
      adStore.SP.group = null;
      next();
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  .ad-badge{
    margin-left: 4px;
    /deep/ .el-badge__content{
      font-weight: 600;
      font-family: PingFangSC-Semibold;
    }
  }
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
